import React, { useEffect, useState, useRef } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import api from "../../Api";
import { useHistory } from "react-router-dom";
const domainpath = process.env.REACT_APP_DOMAIN;

const Tickets = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const history = useHistory();

  const columns = [
    {
      name: "Ticket ID",
      selector: (row) => (
        <a
          href={`${domainpath}/dashboard/edit-ticket/${row?._id}`}
          className=" hover:underline"
          style={{ color: "#003366", fontSize: "14px", fontWeight: 600 }}
        >
          {row._id}
        </a>
      ),
      sortable: true,
      width: "15%",
    },
    {
      name: "Submitted By",
      selector: (row) => row.name,
      sortable: true,
      width: "10%",
    },
    {
      name: "Subject",
      selector: (row) => row.subject,
      sortable: true,
      width: "10%",
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
      width: "25%",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      width: "10%",
    },
    {
      name: "Actions",
      cell: (row) => (
        <button
          className="ViewDetails-tickets text-white px-4 py-2 rounded-lg"
          onClick={(e) => history.push(`/dashboard/ticket/${row?._id}`)}
        >
          View Details
        </button>
      ),
      width: "20%",
    },
  ];

  const tableData = {
    columns,
    data,
  };
  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);

        const response = await api.getTicketByUserId();
        if (response.status === 200) {
          setData(response?.tickets);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);
  return (
    <div className="p-8">
      <div className="bg-white p-4 rounded-lg shadow">
        <div className="flex justify-between items-center py-5">
          <h2 className="text-lg font-bold mb-4" style={{ color: "#003366" }}>
            Tickets
          </h2>
          <div className="">
            <a href="/dashboard/add-ticket">
              <button className="manage-edit-btn text-white px-3 py-2">
                Add Ticket
              </button>
            </a>
          </div>
        </div>

        {loading ? (
          <p>Loading...</p>
        ) : (
          <DataTableExtensions {...tableData}>
            <DataTable
              columns={columns}
              data={data}
              defaultSortField="id"
              defaultSortAsc={false}
              pagination
              highlightOnHover
              className="custom-scrollbar"
            />
          </DataTableExtensions>
        )}
      </div>
    </div>
  );
};

export default Tickets;
